import { z } from "zod";

export const templateReportSettingsOwnerSchema = z.object({
    kind: z.literal("template"),
    templateId: z.string(),
});

export const workspaceReportSettingsOwnerSchema = z.object({
    kind: z.literal("workspace"),
    workspaceId: z.string().uuid(),
});

export const entityReportSettingsOwnerSchema = z.object({
    kind: z.literal("entity"),
    entityId: z.number().int(),
});

export const reportSettingsOwnerSchema = z.discriminatedUnion("kind", [
    templateReportSettingsOwnerSchema,
    workspaceReportSettingsOwnerSchema,
    entityReportSettingsOwnerSchema,
]);
